import * as register from '../actions/register';
import {AccessRequest} from '../models/access-request';
import * as auth from '../actions/authentication';

export interface State {
  currentItem: AccessRequest;
  requests: AccessRequest[];
  requestSubmitted: boolean;
  requestType: string;
  approvingId: number;
  denyingId: number;
  working: boolean;
}

export const initialState: State = {
  currentItem: {},
  requests: [],
  requestSubmitted: false,
  requestType: 'PENDING',
  approvingId: 0,
  denyingId: 0,
  working: false
};

export function reducer(state = initialState, action: any): State {
  let newState: State;
  let idx: number;
  let newRequests: AccessRequest[];
  let request: AccessRequest;

  switch (action.type) {

    case register.REQUEST_ACCESS:
      newState = Object.assign({}, state);
      newState.working = true;
      newState.currentItem = action.payload;
      return newState;

    case register.REQUEST_ACCESS_COMPLETE:
      newState = Object.assign({}, state);
      newState.requestSubmitted = true;
      newState.currentItem = new AccessRequest();
      newState.working = false;
      return newState;

    case register.LOAD_ACCESS_REQUESTS:
      newState = Object.assign({}, state);
      newState.requestType = action.payload;
      return newState;

    case register.LOAD_ACCESS_REQUESTS_COMPLETE:
      newState = Object.assign({}, state);
      newState.requests = action.payload;
      return newState;

    case register.APPROVE_ACCESS_REQUEST:
      newState = Object.assign({}, state);
      newState.currentItem = action.payload;
      newState.working = true;
      newState.approvingId = action.payload.id;
      return newState;

    case register.APPROVE_ACCESS_REQUEST_COMPLETE:
      newState = Object.assign({}, state);
      newRequests = newState.requests.slice();
      request = Object.assign({}, newState.currentItem);
      request.granted = true;
      newState.working = false;
      newState.approvingId = 0;
      idx = newRequests.map(e => { return e.id; }).indexOf(newState.currentItem.id);
      if (newState.requestType === 'ALL') {
        newRequests.splice(idx, 1, request);
      } else {
        newRequests.splice(idx, 1);
      }

      newState.requests = newRequests;
      return newState;

    case register.DENY_ACCESS_REQUEST:
      newState = Object.assign({}, state);
      newState.currentItem = action.payload;
      newState.denyingId = action.payload.id;
      newState.working = true;
      return newState;

    case register.DENY_ACCESS_REQUEST_COMPLETE:
      newState = Object.assign({}, state);
      newRequests = newState.requests.slice();
      request = Object.assign({}, newState.currentItem);
      request.denied = true;
      newState.denyingId = 0;
      newState.working = false;
      idx = newRequests.map(e => { return e.id; }).indexOf(newState.currentItem.id);
      if (newState.requestType === 'ALL') {
        newRequests.splice(idx, 1, request);
      } else {
        newRequests.splice(idx, 1);
      }
      newState.requests = newRequests;
      return newState;

    case register.CLEAR_ACCESS_REQUEST_SCREEN:
      newState = Object.assign({}, initialState);
      return newState;

    case 'ERROR':
      newState = Object.assign({}, state);
      newState.working = false;
      return newState;

    case auth.LOGOUT:
      return initialState;

    default:
      newState = Object.assign({}, state);
      return newState;
  }
}

export const getRequestList = (state: State) => state.requests;
export const getCurrentRequest = (state: State) => state.currentItem;
export const getRequestSubmitted = (state: State) => state.requestSubmitted;
export const getRequestType = (state: State) => state.requestType;
export const getRequestWorking = (state: State) => state.working;
export const getRequestApproveId = (state: State) => state.approvingId;
export const getRequestDenyId = (state: State) => state.denyingId;



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/reducers/register.ts